export const TARGET_BROWSERS = {
  browsers: ['last 2 versions', 'safari >= 7'],
};

export const TARGET_NODE_6 = {
  node: '6.10',
};

export default (targets = TARGET_BROWSERS, opts = {}) => ({
  test: /\.jsx?$/,
  loader: 'babel-loader',
  exclude: /node_modules/,
  options: {
    babelrc: false,

    presets: [[
      'env', {
        targets,
      },
    ], [
      'stage-2',
    ], [
      'react',
    ]],

    plugins: [
      'syntax-export-extensions',
      'transform-export-extensions',
    ],

    ...opts,
  },
});
